<h1 class="pb-5">{{ 'CATEGORIES.title' | translate: { count: 0 } }}</h1>
@if (categoryList) {
  <app-cards-basic title="{{ 'CATEGORIES.list' | translate }}">

    <mat-nav-list>
      @for (category of categoryList; track category; ) {
        <a mat-list-item
           [routerLink]="[category.id]"
           class="list-border-bottom">
          <span matListItemTitle>
            {{  category.translations[currentLanguage].name }}
          </span>
          <!-- Delete Button -->
          <button mat-icon-button
                  (click)="confirmDelete(category.id, $event)"
                  aria-label="Delete"
                  class="trailing-end-button">
            <mat-icon>
              <span class="material-symbols-outlined">delete</span>
            </mat-icon>
          </button>
        </a>
      }
    </mat-nav-list>

    <button mat-flat-button
            color="primary"
            type="button"
            [routerLink]="['new-category' | localize]"
            class="bp-button">
      {{ 'CATEGORIES.create' | translate }}
    </button>


  </app-cards-basic>
}


@if (_authService.isAuthenticated()) {
}

